export default {
  quoteAttachments: [],
  quoteAttachment: undefined,
};
